import DiagnosticProcedureDetailDataModel from '../data-models/DiagnosticProcedureDetail.DataModel';
import { apiGet } from '../support/helpers/ApiConnection.Helper';

export default function getDiagnosticProcedureDetailByServiceTypeId(serviceTypeId: number,abortSignal: AbortSignal): Promise<Array<DiagnosticProcedureDetailDataModel>> {   
    return apiGet<Array<DiagnosticProcedureDetailDataModel>>('/diagnostic-procedure-detail/service-Type/' + serviceTypeId,abortSignal);
}

export function getAllDiagnosticProcedureDetail(abortSignal: AbortSignal): Promise<Array<DiagnosticProcedureDetailDataModel>> {   
    return apiGet<Array<DiagnosticProcedureDetailDataModel>>('/diagnostic-procedure-detail',abortSignal);
}